var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed inset-0 z-50 flex items-center justify-center bg-black/60"},[_c('div',{staticClass:"bg-[#1F1444] rounded-2xl w-[90%] p-5 text-white shadow-xl animate-[fadeIn_0.3s_ease-out_forwards]"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }